module.exports = __webpack_public_path__ + "static/img/保险中心@3x.669d913.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/dhry/assets/navs/保险中心@3x.png
// module id = 308
// module chunks = 379 380